import api from './../../api'

const recurrenceAPI = api.create('recurrence')

const get = ({ functionalityId = '', ...params }) => {
  return recurrenceAPI.get(`/functionalities/${functionalityId}`, {
    params,
  })
}

export default { get }
